// LivestreamSuperChatOverlay.js
import { connect } from 'react-redux';

import LivestreamSuperChatOverlay from '../component/LivestreamSuperChatOverlay.jsx';

import getUserData from '../selector/getUserData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { FEATURE_DISPLAY_NAME } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { userId }) => {
  return {
    username: getUserData(state, userId, 'username'),
    displayName: getUserData(state, userId, 'displayName'),
    isDisplayNameEnabled:
      getRemoteConfigData(state, FEATURE_DISPLAY_NAME) === 1,
    superChatOptionData: getRemoteConfigData(state, 'superChatOptionData'),
  };
};

export default connect(mapStateToProps)(LivestreamSuperChatOverlay);
